export enum PositionEnum {
  TOP = 'top',
  TOP_REVERSED = 'top-reversed',
  BOTTOM = 'bottom',
  LEFT = 'left',
  RIGHT = 'right',
}
